import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import TrustStrip from './components/TrustStrip';
import SummitApproach from './components/SummitApproach';
import Industries from './components/Industries';
import SummitSystems from './components/SummitSystems';
import Results from './components/Results';
import WhySantislogix from './components/WhySantislogix';
import CaseStudies from './components/CaseStudies';
import FinalCTA from './components/FinalCTA';
import Footer from './components/Footer';

export default function HomePage() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const navLinks = [
    { label: 'Approach', href: '#approach' },
    { label: 'Industries', href: '#industries' },
    { label: 'Systems', href: '#systems' },
    { label: 'Results', href: '#results' },
  ];

  return (
    <div className="min-h-screen bg-white">
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
          scrolled
            ? 'bg-white/80 backdrop-blur-xl border-b border-slate-200/50'
            : 'bg-transparent'
        }`}
      >
        <div className="w-full px-8 py-4 flex items-center justify-between">
          <a href="/" className="flex items-center cursor-pointer">
            <img
              src="https://static.readdy.ai/image/0fc33fa68f46f743570ad8ba1c3172ea/e2810a222c84ca6d6d2cab0352aac7a5.png"
              alt="Santislogix"
              className="h-[90px] w-[90px] object-contain"
            />
          </a>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map(link => (
              <a
                key={link.label}
                href={link.href}
                className={`text-sm transition-colors whitespace-nowrap cursor-pointer ${
                  scrolled ? 'text-slate-600 hover:text-slate-900' : 'text-white/70 hover:text-white'
                }`}
              >
                {link.label}
              </a>
            ))}
          </div>

          <div className="flex items-center gap-4">
            <a
              href="#consultation"
              className={`hidden md:inline-flex text-sm transition-colors whitespace-nowrap cursor-pointer ${
                scrolled ? 'text-slate-600 hover:text-slate-900' : 'text-white/70 hover:text-white'
              }`}
            >
              Contact
            </a>
            <a
              href="#consultation"
              className={`text-sm font-medium px-5 py-2 rounded-full transition-all whitespace-nowrap cursor-pointer ${
                scrolled
                  ? 'bg-slate-900 text-white hover:bg-teal-600'
                  : 'bg-white/10 text-white hover:bg-white/20 backdrop-blur-sm border border-white/20'
              }`}
            >
              Book a Call
            </a>
            <button
              onClick={() => setMobileOpen(!mobileOpen)}
              className="md:hidden w-8 h-8 flex items-center justify-center cursor-pointer"
            >
              <i className={`${mobileOpen ? 'ri-close-line' : 'ri-menu-line'} text-xl ${scrolled ? 'text-slate-900' : 'text-white'}`} />
            </button>
          </div>
        </div>

        {mobileOpen && (
          <div className="md:hidden bg-white/95 backdrop-blur-xl border-t border-slate-100 px-8 py-6 space-y-4">
            {navLinks.map(link => (
              <a
                key={link.label}
                href={link.href}
                onClick={() => setMobileOpen(false)}
                className="block text-slate-700 hover:text-teal-600 text-base transition-colors cursor-pointer"
              >
                {link.label}
              </a>
            ))}
            <a
              href="#consultation"
              onClick={() => setMobileOpen(false)}
              className="block bg-teal-500 text-white text-center py-3 rounded-xl font-medium cursor-pointer"
            >
              Book a Call
            </a>
          </div>
        )}
      </nav>

      <Hero />
      <TrustStrip />
      <SummitApproach />
      <Industries />
      <SummitSystems />
      <Results />
      <WhySantislogix />
      <CaseStudies />
      <FinalCTA />
      <Footer />
    </div>
  );
}
